import React, { useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "_common/hooks";
import { Link, useSearchParams } from "react-router-dom";

import classNames from "classnames";
import i18next from "i18next";

import HistoryTrade from "./HistoryTrade";
import ListCoin from "./ListCoin";
import GameChart from "./GameChart";
import Contract1 from "./Contract1";
import Contract2 from "./Contract2";

const ContractPage = observer(() => {
  const {
    authStore: { games, user },
  } = useStores();

  const [params] = useSearchParams();
  const symbol = params?.get("symbol") || "btcusdt";
  const type = params?.get("type") || "coin";
  const [activeHis, setActiveHis] = useState("bet");
  const [activeTab, setActiveTab] = useState("chart");

  const [openModal, setOpenModal] = useState(false);
  const [game_id, setGameId] = useState(games[0]?.code);

  useEffect(() => {
    setGameId(symbol);
  }, [symbol]);

  return (
    <>
      <div className="feature-page spot-page mt-[45px]">
        <div className="feature-header">
          <div className="tabs">
            <div
              className={classNames("tab !flex-auto", {
                active: activeTab === "chart",
              })}
              onClick={() => setActiveTab("chart")}
            >
              {i18next.t("chart")}
            </div>
            <div
              className={classNames("tab !flex-auto", {
                active: activeTab === "transaction",
              })}
              onClick={() => setActiveTab("transaction")}
            >
              {i18next.t("transaction")}
            </div>
          </div>
        </div>
        {activeTab === "chart" && (
          <GameChart game_id={game_id} onChangeTab={setActiveTab} />
        )}
        {activeTab === "transaction" && type === "coin" && (
          <Contract1 game_id={game_id} />
        )}
        {activeTab === "transaction" && type === "commodity" && (
          <Contract2 game_id={game_id} />
        )}
        {activeTab === "transaction" && type === "foreign_exchange" && (
          <Contract2 />
        )}
        <div className="tabs">
          <div
            className={classNames("tab", {
              active: activeHis === "bet",
            })}
            onClick={() => setActiveHis("bet")}
          >
            {i18next.t("position")}
          </div>
          <div
            className={classNames("tab", {
              active: activeHis === "all",
            })}
            onClick={() => setActiveHis("all")}
          >
            {i18next.t("order")}
          </div>
        </div>
        <HistoryTrade status={activeHis} />
      </div>
      {openModal && (
        <ListCoin
          type={activeTab}
          open={openModal}
          onClose={() => setOpenModal(false)}
        />
      )}
    </>
  );
});

export default ContractPage;
